import { ENDPOINTS, QUERY_KEY } from '@/constants';
import { useQuery } from '@tanstack/react-query';
import { notFound } from 'next/navigation';
import { useEffect } from 'react';
import { sendSentryError } from '@lib/sentry';
/**
 * 패널-유전자 매핑 데이터를 가져오고 관리하는 기능
 *
 * 주요 기능:
 * 1. 데이터를 비동기적으로 가져오는 함수 (fetchPanelToGenesMappingData)
 * 2. React Query를 활용한 데이터 캐싱 및 상태 관리
 * 3. 데이터 로딩 상태 및 오류 처리
 * 4. 특정 쿼리 (meta.persist=true)만 로컬 스토리지에 일주일간 유지
 */

const ONE_WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;

const fetchPanelToGenesMappingData = async () => {
  // csv 파일 import시 번들에 포함되므로 fetch 사용
  try {
    const response = await fetch(ENDPOINTS.panelToGenesMappingData);
    return response.json();
  } catch (error) {
    sendSentryError({
      error,
      source: 'gene-coverage-browser-fetch-panel-to-genes-mapping-data',
    });
    throw error;
  }
};

export const usePanelToGenesMappingData = () => {
  const result = useQuery({
    queryKey: [QUERY_KEY.panelToGenesMappingData],
    queryFn: fetchPanelToGenesMappingData,
    staleTime: ONE_WEEK_IN_MS,
    gcTime: ONE_WEEK_IN_MS,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    meta: {
      persist: true, // 이 쿼리는 로컬 스토리지에 캐싱됨을 표시
    },
  });

  useEffect(() => {
    if (result.error) {
      notFound();
    }
  }, [result.error]);

  return result;
};
